import { Component, OnInit, Inject, ViewChild, Input, Output, EventEmitter, ElementRef, SimpleChanges } from '@angular/core';

import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';

import * as Utils from '@shared/core/utils';
import * as Tokens from '@shared/core/tokens';

import { Subscription, Observable } from 'rxjs';

@Component({
    template: '<div>This component requires extending</div>',
})
export class FormTypesComponent implements OnInit {
    public formControl: FormGroup;
    public DOB_REGEXP: RegExp = /([0-9]|\/)+/;
    public hasChanged: boolean = false;
    public minimalDate: Date = new Date(new Date().setFullYear(1900));
    public minAge: Date = Utils.Dates.subtractYearsFromToday(this.config.minimumAgeToSignUp);
    public startDate: Date = Utils.Dates.subtractYearsFromToday(this.config.minimumAgeToSignUp + 10);

    @Input() public formName: string = 'form';
    @Input() public guest: boolean = false;
    @Input() public data: { [key: string]: any; } = null;
    @Input() public emphasis: boolean = false;
    @Input() public compact: boolean = true;
    @Input() public labelName: string = 'First Name';
    @Input() public labelSurname: string = 'Last Name';
    @Input() public labelMobilePhone: string = 'Mobile Number';
    @Input() public placeholderMobilePhone: string = 'Mobile number e.g. 0400-000-000';
    @Input() public labelAccountNumber: string = this.config.signUpRewardsAccountLinking?.cardNumberLabelText || 'Account number';
    @Input() public labelEmail: string = 'Email Address';
    @Input() public placeholderEmail: string = 'Your email e.g. John@email.com';
    @Input() public labelReceivePromo: string = 'Keep me up to date with new menu items & offers';
    @Input() public labelCardNumber: string = 'Card Number';
    @Input() public labelExpiryDate: string = 'Expiry Date (MM/YY)';
    @Input() public labelExpiryMonth: string = 'Expiry Month (MM)';
    @Input() public labelExpiryYear: string = 'Expiry Year (YY)';
    @Input() public labelCVV: string = 'CVV/CID';
    @Input() public labelCardHolderName: string = 'Card Holder Name';
    @Input() public labelSaveCard: string = 'Save this card for quick checkout';
    @Input() public labelSubmitResetPassword: string = 'Reset password';
    @Input() public labelPassword: string = 'Password';
    @Input() public labelPasswordCurrent: string = 'Current Password';
    @Input() public labelPasswordNew: string = 'New Password';
    @Input() public labelPasswordAgain: string = 'Retype New Password';
    @Input() public labelDefaultPaymentMethod: string = 'Make this card default payment method';
    @Input() public labelMemberCard: string = 'Card number';
    @Input() public labelDateOfBirth: string = 'Date of Birth';
    @Input() public labelBirthday: string = 'Birthday';
    @Input() public labelMonth: string = 'Month';
    @Input() public labelDay: string = 'Day';
    @Input() public labelYear: string = 'Year';
    @Input() public labelOptional: string = ' ( optional )'; /* TODO - implement this - pass this value to formInput component */
    @Input() public labelSubmit: string = 'Submit';
    @Input() public labelCancel: string = 'Cancel';
    @Input() public labelAddress: string = 'Address';
    @Input() public placeholderAddress: string = 'Enter your address';
    @Input() public labelTableNumber: string = 'Table number';
    @Input() public labelAddVoucher: string = 'Promotional code';
    @Input() public placeholderAddVoucher: string = 'e.g AAAs9928';
    @Input() public placeholderTableNumber: string = '';
    @Input() public delay: number = null; /* Will delay form submit event - this needs to be implemented separatley for each form */
    @Input() public disabled: boolean = false;

    @Input() public modal: boolean = false;
    @Input() public detachFormSubmitControls: boolean = false;

    /* Not used but form-submit can use that */
    @Input() public alignActions: 'left' | 'right' | 'center' = 'left';
    @Input() public actionsMarginTop: OLO.Components.MARGIN_SIZE = 'md';
    @Input() public actionsMarginBottom: OLO.Components.MARGIN_SIZE = null;

    @Output() public onInit: EventEmitter<FormGroup> = new EventEmitter();
    @Output() public onChange: EventEmitter<FormGroup> = new EventEmitter();
    @Output() public onFormSubmit: EventEmitter<{ event: Event; form: FormGroup; }> = new EventEmitter();

    @ViewChild('dobPicker', { static: true }) public dobPicker!: MatDatepicker<HTMLElement>;
    @ViewChild('form', { static: true }) public form: ElementRef;

    public formChangesListener$: Subscription;
    public loading$: Observable<OLO.Components.LOADING_STATUS>;

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        public formBuilder: FormBuilder,
    ) { }

    ngOnInit(): void {
        this.onInit.emit(this.formControl);
    }

    public handleFormSubmit($event: Event): void {
        console.warn('HANDLE FORM SUBMIT', $event, this.getFormValues());
    }

    public getFormValues(): { [key: string]: any; } {
        return Utils.Forms.extractValues(this.formControl);
    }

    public get buttonWidth(): OLO.Components.BUTTON_WIDTH {
        return Utils.Devices.isMobile() ? 'extended' : 'normal';
    }


    public get buttonSize(): OLO.Components.BUTTON_SIZE {
        return Utils.Devices.isMobile() ? 'xlg' : 'lg';
    }
}
